import styled from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant, truncateText } from "@similarweb/styles";

import { aiAgentColors } from "app/pages/sales-intelligence/modules/ai-agent/components/styles";

export const StyledInsightGraphContainer = styled.div<{ isCompareChart: boolean }>`
    max-width: ${({ isCompareChart }) => (isCompareChart ? "300px" : "100%")};
    box-shadow: 0px 1.367px 2.733px 0px rgba(14, 30, 62, 0.08);
    border-radius: 6px;
`;

export const StyledInsightGraph = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    border: 0.5px solid #ececec;
    background: ${colorsPalettes.carbon[0]};
`;

export const StyledInsightGraphHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 0.5px solid ${colorsPalettes.carbon[100]};
    row-gap: 6px;
`;

export const StyledInsightGraphTitle = styled.h4<{ isSimplifiedView: boolean }>`
    width: 100%;
    ${setFontVariant("primaryItem", colorsPalettes.carbon[500])};
    font-size: 12px;
    margin: 0;

    ${({ isSimplifiedView }) => isSimplifiedView && truncateText()};
`;

export const StyledHeaderSubtitle = styled.span`
    ${setFontVariant("caption2", colorsPalettes.carbon[400])};
    margin-left: 8px;
    ${truncateText()};
`;

export const StyledCountryFlag = styled(SWReactCountryIcons)`
    margin-left: 6px;
`;

export const StyledInsightGraphFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 12px 6px;
    gap: 2px;

    *:first-child {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    & > svg {
        width: 50px;
    }
`;

export const StyledHeaderInfo = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;

    *:not(:last-child) {
        flex: none;
    }
`;

export const StyledBlurOverlay = styled.div`
    position: absolute;
    top: 33px;
    left: 1px;
    width: calc(100% - 4px);
    height: calc(100% - 36px);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    z-index: 2;
    border-radius: 6px;
    border: 1px solid transparent;
`;

export const StyledHoverWrapper = styled.div`
    position: relative;
    border: 1px solid transparent;
    border-radius: 6px;
    isolation: isolate;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        padding: 1px;
        border-radius: inherit;
        background: transparent;
        -webkit-mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
        mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;

        transform: translateZ(0);
        pointer-events: none;
    }

    &:hover {
        &::before {
            background: linear-gradient(
                89.27deg,
                ${aiAgentColors.gradient.blue} 1.62%,
                ${aiAgentColors.gradient.lightBlue} 72.84%,
                ${aiAgentColors.gradient.green} 99.54%
            );
        }

        ${StyledBlurOverlay} {
            opacity: 1;
            pointer-events: all;
        }
    }
`;
